/*
  Ordinalizes the given number, e.g. ordinalize(1) => "1st",
                                     ordinalize(2) => "2nd",
                                     ordinalize(3) => "3rd",
                                     ...

  The rules are as follows:

 - st is used with numbers ending in 1 (e.g. 1st, pronounced first)
 - nd is used with numbers ending in 2 (e.g. 92nd, pronounced ninety-second)
 - rd is used with numbers ending in 3 (e.g. 33rd, pronounced thirty-third)
    As an exception to the above rules, all the "teen" numbers ending with 11, 12 or 13 use -th
    (e.g. 11th, pronounced eleventh, 112th, pronounced one hundred [and] twelfth)

    th is used for all other numbers (e.g. 9th, pronounced ninth).

    Implementation taken from:
    https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
*/
export var ordinalize = function ordinalize(num) {
  var j = num % 10;
  var k = num % 100;
  if (j === 1 && k !== 11) {
    return "".concat(num, "st");
  }
  if (j === 2 && k !== 12) {
    return "".concat(num, "nd");
  }
  if (j === 3 && k !== 13) {
    return "".concat(num, "rd");
  }
  return "".concat(num, "th");
};
export var toRealNumber = function toRealNumber(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return !Number.isNaN(parseFloat(value)) ? Number.parseFloat(value).toFixed(precision) : '';
};
export var formatCurrency = function formatCurrency(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var formattedCurrency = '$0.00';
  if (value) {
    // This will add $ when adding line items
    formattedCurrency = value[0] === '$' ? value : Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: precision
    }).format(value);
  }
  return formattedCurrency;
};
export var formatCurrencyPlain = function formatCurrencyPlain(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (!value) return '';
  return Intl.NumberFormat('en-US', {
    minimumFractionDigits: precision
  }).format(String(value).replace(/,/, ''));
};